import Windows from './Windows';
import HashSource from '../core/HashSource';
import Urls from '../urls/Urls';
import Drag from '../ui_core/Drag';
import Hover from '../ui_core/Hover';
import IconButtonNonReact from '../components/IconButtonNonReact';
import stopEventPropagation from '../ui_core/stopEventPropagation';
import setText from '../ui_core/setText';
import Resizer from '../ui_core/Resizer';
import SelectHelper from '../ui_core/SelectHelper';
import verticallyCenter from '../ui_core/verticallyCenter';
import isMobile from '../core/isMobile';
import eventEnable from '../core/eventEnable';
import Timer from '../core/Timer';
import Settings from '../core/Settings';
import EventNames from './WindowEventNames';
	
const defaults = {
	minWidth:100,
	minHeight:100,
	maxWidth:1000,
	maxHeight:1000,
	minXPerc:0,
	minYPx:0,
	maxXPerc:100,
	maxYPx:10000,
	Resizer:true,
	dragable:true,
	closeable:true,
	minimizable:true,
	maximizable:true,
	minimizeOnClose:false
	
};
var defaultsOptional={};
const GenericWindow= function(params){
	var self = this;
	eventEnable(this);
	this._hash = HashSource.next();
	for(var i in Object.keys(defaults))
	{
		if(params[i]===undefined)
			params[i]=defaults[i];
	}
	
	var previousSizes, maximizedSizes, cancelBringToFront;
	var buttonClose, buttonMinimize, buttonMaximize;
	var timerFlash, flashing = false, flashCount=0;
	
	var name = params.name?params.name:'default';
	var tooltipMessage=params.tooltipMessage;
	let{ iconPath, minWidth, maxWidth, minHeight, maxHeight, defaultWidth, defaultHeight,
		defaultX, defaultY, minimized, maximized,  minimizable, maximizable, closeable, 
		minimizeOnClose, resizable, dragable, minXPerc, maxXPerc, maxYPx, minYPx, zIndexOffset, 
		type, parentElement, element, toggleMaximizeOnDoubleClick, callbackClickedClose}= params;
	if(!element) element = document.createElement('div');
	element.classList.add('generic-window');
	
	const divInner = document.createElement('div');
	divInner.classList.add('inner');
	
	const divTab = document.createElement('div');
	divTab.classList.add('tab');
	
	const divMain = document.createElement('div');
	divMain.classList.add('main');
	
	var divName = document.createElement('div');
	divName.classList.add('name');
	
	setText(divName, name);
	element.appendChild(divInner);
	divInner.appendChild(divTab);
	divTab.appendChild(divName);
	divInner.appendChild(divMain);
	(parentElement?parentElement:document.documentElement).appendChild(element);
	
	
	this.getType= function(){
		return type;
	};
	var saveName = params.saveName? params.saveName:name;
	
	var settings = new Settings(saveName, function () {
		this.set("position");
		this.set("size");
		this.set("zIndex");
	});
	Windows._instances.push(this);
	
	this.flash = flash;
	
	this.getHash=function(){
		return this._hash;
	};
	this.setName = function(name){
		setText(divName, name);
	};
	this.setTooltipMessage = function(value){
		tooltipMessage = value;
	};
	this.getIcon=function(){
		return iconPath;
	};
	this.getTooltip = function(){
		return tooltipMessage;
	};
	this._setZIndex=function(zIndex){
		element.style.zIndex=String(zIndex);
		settings.set("zIndex", zIndex);
		dispatchZIndexChangedEvent();
	};
	this.getState=function(){
		return {maximized:maximized, minimized:minimized};
	};
	this.maximize = maximize;
	this.unmaximize = unmaximize;
	this.minimize = minimize;
	this.toggleMinimize = toggleMinimize;
	this.unminimize=unminimize;
	this.close = close;
	this.focus = focus;
	this.bringToFront = bringToFront;
	this.toggleMaximize = toggleMaximize;
	
	this._screenResized=function(obj) {
		if (maximized&(resizable||!window.isMobile))setWindowSizePositionMaximized();
	}
	
	this.getMinimizable=function(){
		return minimizable;
	};
	this.getElement = function(){
		return element;
	};
	this.getParentElement = function(){
		return parentElement;
	};
	this.getTabElement = function(){
		return divTab;
	};
	this.fillLeftHalf = function(){
		maximized = false;
		unminimize();
		//previousSizes = getSizes();
		if(resizable||!window.isMobile){
			const p = resizable?Resizer.padding:0;
			setWindowSizePosition({
				width:(parentElement?parentElement:document.documentElement).clientWidth/2, 
				height:((parentElement?parentElement:document.documentElement).clientHeight - p),
				top:-p,
				left:-p
			});
		}
		bringToFront();
	};
	this.fillRightHalf = function(){
		maximized = false;
		unminimize();
		//previousSizes = getSizes();
		if(resizable||!window.isMobile){
			const p = resizable?Resizer.padding:0;
			const halfWidth = (parentElement?parentElement:document.documentElement).clientWidth/2;
			setWindowSizePosition({
				width:halfWidth, 
				height:((parentElement?parentElement:document.documentElement).clientHeight - p),
				top:-p,
				left:halfWidth-p
			});
		}
		bringToFront();
	};
	stopEventPropagation(divMain, ['mousedown']);
	divMain.addEventListener('mousedown',clickedOnMe);
	this.getMainElement = function(){
		return divMain;
	};
	this.getPosition = function(){
		return [element.offsetLeft, element.offsetTop];
	};
	(parentElement?parentElement:document.documentElement).classList.add('web-windows');
	SelectHelper.makeUnselectable(element);
	
	document.body.appendChild(element);
	//element.addEventListener("mousedown", clickedOnMe);
	if(toggleMaximizeOnDoubleClick===undefined||toggleMaximizeOnDoubleClick)
		divTab.addEventListener('dblclick', toggleMaximize);
	initializePadding();
	if (!window.isMobile)
	{
		if (resizable)
		{
			self._resizer = new Resizer({div:element, divInner, minWidth, minHeight, maxWidth, maxHeight,
				bounds:self.currentBounds, callbackResized:resized, callbackInstantaneous:resized, 
			callbackStarted:resizerStarted});
		}
		if (dragable)
		{
			self._drag = new Drag(element, divTab, minXPerc, maxXPerc, minYPx,
				maxYPx, dragged, dragStarted);
		}
		
		const fillerElement = document.createElement('div');
		fillerElement.classList.add('filler');
		divTab.appendChild(fillerElement);
		if (minimizable)
		{
			const iconButonMinimize = new IconButtonNonReact({imgUrl:Urls.assets+'icons/UI_Button_Minimize.png', 
			onClick:minimize});
			divTab.appendChild(iconButonMinimize.element);
			stopEventPropagation(iconButonMinimize.element, ['touchstart', 'mousedown']);
		}
		if (maximizable)
		{
			const iconButonMaximize = new IconButtonNonReact({imgUrl:Urls.assets+'icons/UI_Button_Maximize.png', 
			onClick:toggleMaximize});
			divTab.appendChild(iconButonMaximize.element);
			stopEventPropagation(iconButonMaximize.element, ['touchstart', 'mousedown']);
		}
	}
	if (closeable||minimizeOnClose)
	{
		const iconButonClose = new IconButtonNonReact({imgUrl:Urls.assets+'icons/UI_Button_Exit.png', 
			onClick:()=>{
				if(callbackClickedClose){
					if(!callbackClickedClose())
						return;
				}
				if (minimizeOnClose)
					minimize();
				else
					close();
				}
		});
		divTab.appendChild(iconButonClose.element);
		stopEventPropagation(iconButonClose.element, ['touchstart', 'mousedown']);
	}
	if(!window.isMobile){
		var startPosition = settings.get("position");
		if (!startPosition)
		{
			const hasDefaults = (defaultX!==undefined&&defaultY!==undefined);
			startPosition = hasDefaults?[defaultX, defaultY]:Windows.getStartPosition(this);
		}
		element.style.left = String(startPosition[0]) + 'px';
		element.style.top = String(startPosition[1]) + 'px';

		var startSize = settings.get("size");
		if (startSize)
		{
			if (startSize[0] < minWidth)
				startSize[0] = minWidth;
			if (startSize[1] < minHeight)
				startSize[1] = minHeight;
			element.style.width = String(startSize[0]) + 'px';
			element.style.height = String(startSize[1]) + 'px';
		} else
		{
			element.style.width = String(defaultWidth) + 'px';
			element.style.height = String(defaultHeight) + 'px';
		}
	}

	var startZIndex = settings.get("zIndex");
	if (startZIndex)
	{
		element.style.zIndex = String(startZIndex);
	}
	element.appendChild(divInner);
	
	this.setWindowSizePosition = setWindowSizePositionConsideringResizers;
	if(!minimized)_unminimize();
	Windows._dispatchWindowCreatedEvent(self);
	if (bringToFront != false)self.bringToFront();
	function show()
	{
		element.classList.add('visible');
	}
	function hide()
	{
		element.classList.remove('visible');
	}
	function flash(){
		var flashing = false;
		flashCount=0;
		if(!timerFlash)
			timerFlash = new Timer({
				callback:()=> {
				if (flashing) {
					divInner.classList.remove('flashing');
					if(flashCount>=6)
						timerFlash.stop();
					flashing = false;
				} else {
					divInner.classList.add('flashing');
					flashing = true;
				}
				flashCount++;
		}, delay:50, nTicks:-1});
		else{
			timerFlash.reset();
			flashCount=0;
		}
	}
	function setWindowSizePositionMaximized(){
		const p = resizable?(Resizer.padding * 2):0;
		setWindowSizePosition({
			width:(parentElement?parentElement:document.documentElement).clientWidth, 
			height:(parentElement?parentElement:document.documentElement).clientHeight - p ,
			top:resizable?-Resizer.padding:0,
			left:resizable?-Resizer.padding:0
		});
	}
	function setWindowSizePositionConsideringResizers({width, height, top, left}){
		setWindowSizePosition({
			width:width, 
			height:height,
			top:top-Resizer.WIDTH,
			left:left-Resizer.WIDTH
		});
	}
	function clickedOnMe(){
		if(!cancelBringToFront)
			bringToFront();
		cancelBringToFront = false;
		dispatchFocussedEvent();
	}
	function initializePadding(){ 
		var padding=((!window.isMobile)&&resizable)?3:0;
		var paddingString = String(padding) + 'px';
		element.style.padding = paddingString;
		divInner.style.position = 'absolute';
		divInner.style.left = paddingString;
		divInner.style.top = paddingString;
		divInner.style.right = paddingString;
		divInner.style.bottom = paddingString;
	}
	function close()
	{
		Windows._instances.splice(Windows._instances.indexOf(this), 1);
		element.parentNode.removeChild(element);
		dispatchClosedEvent();
		Windows._dispatchWindowDestroyedEvent(self);
	}
	function resized(){
		if(maximized){
			if(!maximizedSizes.equals(getSizes())){
				maximized=false;
			}
		}
		settings.set("position", [element.offsetLeft, element.offsetTop]);
		settings.set("size", [element.offsetWidth, element.offsetHeight]);
		dispatchResizedEvent();
	}
	function minimize() {
		maximized = false;
		if(minimized) return;
		hide();
		Windows.sendToBack(self);
		minimized=true;
		dispatchMinimizedEvent();
	}
	function unminimize(){
		if(!minimized)
			return;
		_unminimize();
	}
	function _unminimize(){
		show();
		minimized=false;
		dispatchUnminimizedEvent();
		bringToFront();
	}
	function toggleMinimize(){
		
		if(minimized) unminimize();
		else minimize();
	}
	function maximize()
	{
		if(maximized)return;
		unminimize();
		previousSizes = getSizes();
		if(resizable||!window.isMobile)
			setWindowSizePositionMaximized();
		maximizedSizes = getSizes();
		maximized = true;
		dispatchMaximizedEvent();
		bringToFront();
	}
	function unmaximize(mouseDragPosition)
	{
		if(!maximized)return;
		if (previousSizes)
		{
			if (!mouseDragPosition)
				setWindowSizePosition({
					width:previousSizes.width,
					height:previousSizes.height,
					top:previousSizes.top,
					left:previousSizes.left
				});
			else {
				var b = mouseDragPosition.left / (parentElement?parentElement:document.documentElement).clientWidth;
				var leftOffset = (b * previousSizes.width);
				var l = mouseDragPosition.left - leftOffset;
				setWindowSizePosition({
					width:previousSizes.width, 
					height:previousSizes.height,
				left:l
				});
			}
		}
		maximized = false;
		self._drag?.updateMinMax();
		dispatchUnmaximizedEvent();
	}
	function toggleMaximize()
	{
		if (!maximized)
		{
			maximize();
		}
		else
		{
			unmaximize();
		}
	}
	function bringToFront()
	{
		const instances = Windows._instances;
		const instance = instances.splice(instances.indexOf(self), 1)[0];
		instances.push(instance);
		Windows._updateZIndices();
	};
	function focus(){
		bringToFront();
		dispatchFocussedEvent();
	}
	function dragged(){
		settings.set("position", [element.offsetLeft, element.offsetTop]);
		dispatchMovedEvent();
		dispatchDraggedEvent();
	}
	function dragStarted(e){
		if(maximized)
			unmaximize({left: e.screenX});
		dispatchDragStarted();
	}
	function getSizes()
	{
		var p = Resizer.padding * 2;
		return new (function(){
				var self = this;
				this.width=element.offsetWidth - p; 
				this.height= element.offsetHeight - p; 
				this.top= element.offsetTop;
				this.left= element.offsetLeft;
				this.equals=function(s){
					return self.width==s.width&&self.height==s.height&&self.top==s.top&&self.left==s.left;
				};
		})();
	}

	function setWindowSizePosition(params)
	{
		element.style.height = String(params.height) + 'px';
		element.style.width = String(params.width) + 'px';
		if (params.top!==undefined)
			element.style.top = String(params.top) + 'px';
		if (params.left!==undefined)
			element.style.left = String(params.left) + 'px';
	}
	function resizerStarted(){
		maximized = false;
		dispatchResizerStartedEvent();
	}
	function dispatchResizedEvent(){
		self.dispatchEvent({type:EventNames.RESIZED});
	}
	function dispatchResizerStartedEvent(){
		self.dispatchEvent({type:EventNames.RESIZE_STARTED});
	}
	function dispatchMaximizedEvent(){
		self.dispatchEvent({type:EventNames.MAXIMIZED});
	}
	function dispatchMinimizedEvent(){
		self.dispatchEvent({type:EventNames.MINIMIZED});
	}
	function dispatchUnminimizedEvent(){
		self.dispatchEvent({type:EventNames.UNMINIMIZED});
	}
	function dispatchUnmaximizedEvent(){
		self.dispatchEvent({type:EventNames.UNMAXIMIZED});
	}
	function dispatchDragStarted(){
		self.dispatchEvent({type:EventNames.DRAG_STARTED});
	}
	function dispatchMovedEvent(){
		self.dispatchEvent({type:EventNames.MOVED});
	}
	function dispatchClosedEvent(){
		self.dispatchEvent({type:EventNames.CLOSED});
	}
	function dispatchFocussedEvent(){
		self.dispatchEvent({type:EventNames.FOCUSSED, window:self});
	}
	function dispatchDraggedEvent(){
		self.dispatchEvent({type:EventNames.DRAGGED});
	}
	function dispatchZIndexChangedEvent(){
		self.dispatchEvent({type:EventNames.Z_INDEX_CHANGED});
	}
};
GenericWindow.EventNames = EventNames;
export default GenericWindow;